module.exports = {"username":"demo.kppbc","id":"3","group":"beacukai","status":"enabled","detil":{"nama":"Demo Kppbc","nip":"111111111111111111","pangkat":"Pengatur Tk. I - II/d","kode_eselon2":"070000","eselon2":"Kanwil DJBC Jawa Timur I","kode_eselon3":"071500","eselon3":"KPPBC TMP B SIDOARJO","kantor":"KPPBC TMP B SIDOARJO","kantor_id":"071500","kantor_level":"eselon3"},"roleInfo":{"siroleg":[{"role":"siroleg.bc.analis","role_name":"Analis Beacukai","name":"siroleg","domains":"siroleg.beacukai.go.id","description":"Siroleg","icon":null}]}}


//////////////////
// WEBPACK FOOTER
// ./src/router/fake_tokens/token_kppbc.json
// module id = FTlq
// module chunks = 10